import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Output,
} from '@angular/core';

@Directive({
  selector: '[outsideClick]',
  standalone: true,
})
export class OutsideClickDirective {
  @Output('outsideClick') close = new EventEmitter();

  constructor(private el: ElementRef) {}

  @HostListener('document:click', ['$event'])
  public handleClick(event: MouseEvent) {
    if (!this.el.nativeElement.contains(event.target)) {
      this.close.emit();
    }
  }
}
